export default {"src":"/_next/static/media/rainbow.387fdbbb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};